import { memo, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import "./FaqCategory.scss";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { sendTagOnFaqCategoryPage } from "app/utils/analytics";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const FaqCategory = ({ faqCategories }) => {
	const param = useParams();
	const categoryId = param.categoryId;

	const faqCategory = faqCategories.find(faqCategory => {
		return faqCategory.id === categoryId;
	});

	useEffect(() => {
		if (faqCategory) {
			sendTagOnFaqCategoryPage(faqCategory.name);
		}
	}, [faqCategory]);

	if (faqCategory) {
		return (
			<div className="faq-category">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL}
					variantMD={TYPOGRAPHY_VARIANTS.XL5}
					isBold
					className="faq-category__name"
				>
					{faqCategory.name}
				</Typography>
				<div>
					{faqCategory.subCategories.map(subCategory => {
						return (
							<div key={subCategory.id} className="faq-category__content">
								<div className="faq-category__subcategory-name">
									<RelativeLink
										to={{
											pathname: `/faq/category/${
												faqCategory.id
											}/subcategory/${subCategory.id}`,
										}}
									>
										<i className="icon icon--chevron" /> {subCategory.name}
									</RelativeLink>
								</div>
								<section>
									{subCategory.articles.map(article => {
										return (
											<div key={article.id} className="faq-category__article">
												<RelativeLink
													to={{
														pathname: `/faq/category/${
															faqCategory.id
														}/subcategory/${subCategory.id}/article/${
															article.id
														}`,
													}}
												>
													{article.title}
												</RelativeLink>
											</div>
										);
									})}
								</section>
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	return null;
};

FaqCategory.propTypes = {
	faqCategories: PropTypes.array,
};

FaqCategory.defaultProps = {
	faqCategories: [],
};

export default memo(FaqCategory);
